import { render, staticRenderFns } from "./form.vue?vue&type=template&id=2c22aad3&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=2c22aad3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22aad3",
  null
  
)

export default component.exports